import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconEdit = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" size={size} {...props}>
        <StyledPath
            fillRule="evenodd"
            d="M11.7 3l2.8 2.8-7.7 7.7H4v-2.8zM4 17h12.6"
            strokeWidth="1.4"
            stroke={color}
            color="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </StyledSvg>
);
